'use client';

import { Button } from '@/components/ui/button';
import { ShowSearch } from '@/lib/frontend/store/actionCreators/SearchActions';
import { useAppStore } from '@/lib/frontend/store/hooks';
import { cn } from '@/lib/shared/ui';
import { SearchIndexType } from '@/types/search';
import { Search } from 'lucide-react';
import React from 'react';

const versionMap: Record<string, SearchIndexType> = {
  'v5': SearchIndexType.DocsV5,
  'v4': SearchIndexType.DocsV4,
  'v3': SearchIndexType.DocsV3,
  'v2': SearchIndexType.DocsV2,
  'v1': SearchIndexType.DocsV1,
}

export const DocsSearchButton = ({ className, version }: { className?: string, version?: string }) => {
  const store = useAppStore();

  return (
    <Button
      onClick={() => {
        ShowSearch(store, {
          filterTypes: [versionMap[version || 'v5'] || SearchIndexType.DocsV5],
        });
      }}
      variant="outline"
      className={cn('w-full font-normal justify-start bg-accent-three/20 hover:bg-accent-three/30 text-foreground/50', className)}
    >
      <Search className="w-4 h-4 mr-2" />
      Search documentation
    </Button>
  );
};
